
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import PriceSection from "./price/PriceSection";
import SummarySection from "./summary/SummarySection";

export default function WebinarPurchase() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
	const params = useParams();
	const webinarId = params.webinarId;
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'وبینارها', href: '/webinar_list/' },
		{ label: 'خرید وبینار', href: '/webinar_purchase/' + webinarId + '/' },
	];
	const [webinar, setWebinar] = useState(null);
	const [errorMessage, setErrorMessage] = useState('');

	useEffect(() => {
		fetchWebinar();
	}, []);

	function fetchWebinar() {
		api.webinarDetail({
			token: LoginHelper.getToken(),
			webinar_id: webinarId,
		}).then((result) => {
			setWebinar(result);
		}).catch((err) => {
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		})
	}

	return (
		<>
			<Helmet>
				<title>خرید وبینار | همراهتیم</title>
				<meta name="description" content="خرید وبینار همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[1200px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div className="spacer p-[50px]"></div>
					<div className={`${isDesktop ? 'w-[1200px]' : 'p-[10px]'} mx-auto`}>
						{webinar && (
							<>
								<div className="flex-grow">
									<SummarySection webinar={webinar} />
									<div className="spacer p-[10px]"></div>
									<PriceSection webinar={webinar} />
									<div className="spacer p-[100px]"></div>
								</div>
								<div className="spacer p-[10px]"></div>
							</>
						)}
					</div>
					{errorMessage && (
						<div className="text-center font-Vazir-400 text-[#cc0000]">{errorMessage}</div>
					)}
				</div>
				<div className="spacer p-[50px]"></div>
				<div>
					<Footer isDesktop={isDesktop} />
				</div>
			</div>
		</>
	)
}
